module.exports = __webpack_public_path__ + "img/damuge.bfdfb620.svg";